import { useContext } from 'react'
import { TestResponseContext } from '@/contexts/TestResponseContext'

export function useTestResponse() {
  const context = useContext(TestResponseContext)
  if (context === undefined) {
    console.error('useTestResponse must be used within a TestResponseProvider')
    throw Error('useTestResponse must be used within a TestResponseProvider')
  }
  return context
} 